import React, { useEffect } from 'react';
import { Row, Col } from 'react-bootstrap';
import { getLogForQualityCheck } from 'src/redux/Actions/VehicleTracking';
import { useDispatch, useSelector } from 'react-redux';
import { ReactComponent as Cube } from 'src/Images/icons/common/cube.svg';
import { ReactComponent as ProductIcon } from 'src/Images/icons/common/product.svg';

function QualityCheckLogDetail({ qualityChecklogId }) {
  const dispatch = useDispatch();
  const authReducer = useSelector((state) => state.AuthReducer);
  const tenantOrganisationId = authReducer.userData.organisations?.id;

  const vehicleTrackingReducer = useSelector(
    (state) => state.VehicleTrackingReducer,
  );
  const { getLogDataForQualityCheck } = vehicleTrackingReducer;

  useEffect(() => {
    dispatch(getLogForQualityCheck(tenantOrganisationId, qualityChecklogId));
  }, [dispatch, tenantOrganisationId, qualityChecklogId]);
  return (
    <div className="page-layout div-flex-column rg-10">
      <div className="div-flex-row left-padding border-bottom div-space-between div-align-center">
        <span className="text-xxl text-bold">Quality Check Log</span>
      </div>
      <div className="div-flex-column rg-20 left-padding">
        <Row className="g-3 div-align-center">
          <Col xxl={4} xl={4} lg={4}>
            <span className="text-sm text-semi-bold">Quality Check Name</span>
            <input
              className="form-input-section"
              name="qualityCheckName"
              value={getLogDataForQualityCheck.qualityCheckName}
              disabled
            />
          </Col>

          <Col xxl={6} xl={6} lg={6}>
            <span className="text-sm text-semi-bold">Description</span>
            <input
              className="form-input-section"
              name="description"
              placeholder="Input Description"
              value={getLogDataForQualityCheck.qualityCheckLogTimestamp}
              disabled
            />
          </Col>
        </Row>
      </div>
      <div className="div-flex-row cg-10 padding-top-10 left-padding right-padding">
        <div
          className={`div-flex-column rg-5 ${
            getLogDataForQualityCheck?.products?.length === 0
              ? 'border-right'
              : ''
          }`}
        >
          {getLogDataForQualityCheck?.products?.length === 0 ? (
            <>
              <div className=" div-flex-row cg-5 div-align-center">
                <ProductIcon className="icon-size-xxl" />
                <span className="text-md text-bold">Product list</span>
              </div>
              <div className="quality-check-drawer-empty-state-height div-flex-column-center rg-5">
                <ProductIcon className="icon-size-large" />
                <span className="text-md text-grey">No products attached</span>
              </div>
            </>
          ) : (
            <>
              <div className=" div-flex-row cg-5 div-align-center">
                <ProductIcon className="icon-size-xxl" />
                <span className="text-md text-bold">Product list</span>
              </div>
              <div className="activity-log-item-table-wrapper">
                <table className="quality-check-order-item-table">
                  <thead>
                    <tr>
                      <th className="table-head-30">
                        <span className="text-sm text-grey text-semi-bold">
                          #
                        </span>
                      </th>
                      <th className="table-head-120">
                        <span className="text-sm text-grey text-semi-bold">
                          Dimension Name
                        </span>
                      </th>
                      <th className="table-head-300">
                        <span className="text-sm text-grey text-semi-bold">
                          Dimension Value
                        </span>
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {getLogDataForQualityCheck?.products?.map((dim, index) => (
                      <tr key={dim.id}>
                        <td>
                          <span className="text-sm div-align-center">
                            {index + 1}
                          </span>
                        </td>
                        <td>
                          <span className="text-sm text-nowrap">
                            {dim.name}
                          </span>
                        </td>
                        <td className="text-sm text-nowrap text-ellipsis">
                          <span className="text-sm">{dim.description}</span>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </>
          )}
        </div>

        <div className=" div-flex-column rg-5">
          {getLogDataForQualityCheck?.dimensions?.length === 0 ? (
            <>
              <div className=" div-flex-row cg-5 div-align-center">
                <Cube className="icon-size-xxl" />
                <span className="text-md text-bold">Dimension list</span>
              </div>
              <div className="quality-check-drawer-empty-state-height div-flex-column-center rg-5">
                <Cube className="icon-size-large" />
                <span className="text-md text-grey">
                  No Dimensions attached
                </span>
              </div>
            </>
          ) : (
            <>
              <div className=" div-flex-row cg-5 div-align-center">
                <Cube className="icon-size-xxl" />
                <span className="text-md text-bold">Dimensions list</span>
              </div>
              <div className="activity-log-item-table-wrapper">
                <table className="quality-check-order-item-table">
                  <thead>
                    <tr>
                      <th className="table-head-30">
                        <span className="text-sm text-grey text-semi-bold">
                          #
                        </span>
                      </th>
                      <th className="table-head-120">
                        <span className="text-sm text-grey text-semi-bold">
                          Dimension Name
                        </span>
                      </th>
                      <th className="table-head-300">
                        <span className="text-sm text-grey text-semi-bold">
                          Dimension Value
                        </span>
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {getLogDataForQualityCheck?.dimensions?.map(
                      (dim, index) => (
                        <tr key={dim.id}>
                          <td>
                            <span className="text-sm div-align-center">
                              {index + 1}
                            </span>
                          </td>

                          <td>
                            <span className="text-sm text-nowrap">
                              {dim.dimension_name}
                            </span>
                          </td>
                          <td className="text-sm text-nowrap text-ellipsis">
                            <span className="text-sm">{dim.value}</span>
                          </td>
                        </tr>
                      ),
                    )}
                  </tbody>
                </table>
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
}

export default QualityCheckLogDetail;
